import { useCallback } from 'react';

import { Button } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useCreateUserContext } from '@/features/user/contexts/CreateUserContext';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';

// Hide temporarily the documentation button while waiting for the updated docs
export const Layout = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isDirty } = useCreateUserContext();

  const { t } = useTranslation();

  const showPreventModal = useCallback(() => {
    if (!isDirty) {
      navigate(-1);
      return;
    }

    dispatch(openModal('createUserDiscardModal'));
  }, [isDirty, dispatch, navigate]);

  return (
    <>
      <div className="flex items-center justify-between bg-primary p-4 shadow-100">
        <Button icon="arrow_back" variant="ghost" onClick={showPreventModal}>
          {t('pages.dashboard.userCreation.back_to_dashboard')}
        </Button>
        <div className="flex items-center gap-4 pr-4">
          {/* <Button
            variant="secondary"
            icon="arrow_outward"
            iconPosition="right"
            size="s"
            as="a"
            href="https://docs.treezor.com/guide/dashboard/introduction.html"
            openNewTab={true}
          >
            {t('pages.dashboard.userCreation.dashboard_documentation')}
          </Button> */}
        </div>
      </div>
      <div className="p-6">{children}</div>
    </>
  );
};
